import { makeStyles, withStyles } from '@material-ui/styles'
import { amber } from '@material-ui/core/colors'
import { TableRow, TableCell } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    heading: {
		fontSize: theme.typography.pxToRem(15),
		fontWeight: theme.typography.fontWeightRegular,
	},
	expansionPanel: {
		display: 'block'
	},
	headCountReportPanel: {
		display: 'flow-root'
	},
	divider: {
		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(4),
		height: 1,
		backgroundColor: "#D8D8D880",
	  },
    table: {
        minWidth: 700,
    },
    notificationSpan: {
        float: 'right',
        color: 'red',
        paddingTop: '10px'
    },
    container: {
        display: 'flex'
    },
    graphContainer: {
        paddingLeft: '7%'
    },
    filterContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(2),
    },
    forecastSelectionArea: {
		width: 250,
		display: 'block',
		// marginBottom: 14,
		margin: '0 auto',
		// paddingBottom: 13,
    },
    selectionArea: {
		height: '400px',
    },
    textSelectionArea: {
        height: '100px',
    },
    textArea: {
		width: '100%',
    },
    selectionOR: {
		textAlign: 'center',
    },
    toolBar: {
		paddingTop: 10,
		paddingLeft: 5,
		paddingRight: 5,
		paddingBottom: 10,
		// backgroundColor: '#dfefec',
	},
	lowercaseBtn: {
		textTransform: 'none',
	},
	functionSelect: {
		width: 200,
	},
	subFunctionSelect: {
		width: 200,
	},
	classificationSelect: {
		width: 200,
	},
	titleSelect: {
		width: 200,
    },
    categorySelect: {
        width: 150,
    },
	jobLevelSelect: {
		width: 100,
	},
	countrySelect: {
		width: 150,
	},
	citySelect: {
		width: 150,
	},
	workForceTable: {
		root: {
			'&:hover': {
				backgroundColor: "#f00",
			 },
			backgroundColor: 'red'
		},
		'& table:first-child': {
			'& tr': {
				'& td:first-child, th:first-child': {
					backgroundColor: '#f5f5f5',
					position: 'sticky',
					left: 0,
					zIndex: 100,
				},
				'& th:first-child': {
					zIndex: 1001,
				},
			},
		},
    },
    customStyles : {
        menu: (provided, state) => ({
            ...provided,
            zIndex: 999999999
        }),
    },
    footerLabelCell: {
		border: 'solid 1px lightgrey !important',
		paddingTop: '5px !important',
		paddingBottom: '5px !important'
	},
	footerLabelRow: {
		height: '0px'
	},
    button: {
        margin: theme.spacing(1),
    },
    warningButton: {
        backgroundColor: amber[700],
    },
    hidden: {
        display: 'none',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        width: 'fit-content',
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 200,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    boldtext: {
        fontWeight: 'bold',
    },
    typo: {
        color: theme.palette.text.hint,
        marginTop: theme.spacing(1),
    },
    bgBlack: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        border: 'solid 1px lightgrey',
    },
    bgBlueGrey: {
        backgroundColor: '#424242',
        color: theme.palette.common.white,
        border: 'solid 1px lightgrey',
    },
    bgWhite: {
        border: '1px solid #ffffff',
    },
    bgGrey: {
        backgroundColor: '#616161',
        color: theme.palette.common.white,
    },
    bgLightGrey: {
        backgroundColor: '#757575',
        color: theme.palette.common.white,
    },
    bgLightBlue: {
        backgroundColor: '#dbe5f1',
        color: theme.palette.common.black,
        border: '1px solid white',
    },
    bgLightGreen: {
		backgroundColor: '#6fcdb3',
		color: theme.palette.common.black,
		border: '1px solid white',
    },
    noBorder: {
        border: '0 !important',
    },
    emptyRow: {
        height: '40px !important',
    },
    leftJustified: {
        textAlign: 'left !important',
    },
    reportTableContainer: {
        marginTop: 14,
        width: '500px',
		paddingBottom: '15px'
    },
}))


const StyledTableCell = withStyles(theme => ({
    head: {
        padding: theme.spacing(1),
        fontSize: 12,
        border: 'solid 1px lightgrey',
        textAlign: 'center',
        whiteSpace: 'nowrap',
    },
    body: {
        fontSize: 11,
        textAlign: 'center',
        whiteSpace: 'nowrap',
    },
}))(TableCell)

const StyledTableRow = withStyles(theme => ({
    root: {
        height: 'auto',
    },
}))(TableRow)

export {
    useStyles,
    StyledTableCell,
    StyledTableRow,
}